import { api } from "@/lib/api";

export const StaffAttendanceAPI = {
  daily: (params) => api.get("/staff-attendance/day", { params }).then((r) => r.data),
  rollcall: (body) => api.post("/staff-attendance/rollcall", body).then((r) => r.data),
  checkIn: (body = {}) => api.post("/staff-attendance/check-in", body).then((r) => r.data),
  checkOut: (body = {}) => api.post("/staff-attendance/check-out", body).then((r) => r.data),
  meToday: () => api.get("/staff-attendance/me/today").then((r) => r.data),
  editRecord: (id, body) => api.patch(`/staff-attendance/${id}`, body).then((r) => r.data),
  staffMonth: (sid, params) => api.get(`/staff-attendance/staff/${sid}/month`, { params }).then((r) => r.data),
  kpi: (params) => api.get("/staff-attendance/reports/kpi", { params }).then((r) => r.data),
  myGeofence: () => api.get("/staff-attendance/geofence").then((r) => r.data),
};

export const CampusGeofenceAPI = {
  get: (cid) => api.get(`/campuses/${cid}/geofence`).then((r) => r.data),
  update: (cid, body) => api.patch(`/campuses/${cid}/geofence`, body).then((r) => r.data),
};

export const StaffLeavesAPI = {
  request: (body) => api.post("/staff-leaves", body).then((r) => r.data),
  mine: () => api.get("/staff-leaves/mine").then((r) => r.data),
  inbox: (status = "pending") => api.get("/staff-leaves/inbox", { params: { status } }).then((r) => r.data),
  approve: (id, note) => api.post(`/staff-leaves/${id}/approve`, { note }).then((r) => r.data),
  reject: (id, note) => api.post(`/staff-leaves/${id}/reject`, { note }).then((r) => r.data),
  cancel: (id) => api.post(`/staff-leaves/${id}/cancel`).then((r) => r.data),
  myBalance: () => api.get("/staff-leaves/balances/mine").then((r) => r.data),
  staffBalance: (sid) => api.get(`/staff-leaves/balances/${sid}`).then((r) => r.data),
};
